module.exports = "<div class=\"col-md-6 col-sm-6 col-xs-12\">\n  <div class=\"info-box\">\n    <span class=\"info-box-icon bg-aqua\"><i class=\"fa fa-cog\"></i></span>\n\n    <div class=\"info-box-content\">\n      <span class=\"info-box-text\">Average number of tracker per user</span>\n      <span class=\"info-box-number\">{{ statValue }}</span>\n    </div>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/pages/dashboard/misc/nb-average-tracker-per-user/nb-average-tracker-per-user.html
// module id = ../../../../../src/app/components/pages/dashboard/misc/nb-average-tracker-per-user/nb-average-tracker-per-user.html
// module chunks = main